// Ids that work everywhere: Workers, secure and insecure browser contexts.
// crypto.randomUUID is missing on plain-http pages, getRandomValues is not.

const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

export function randomString(length: number, alphabet = ALPHABET): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < length; i++) out += alphabet[bytes[i] % alphabet.length];
  return out;
}

export function newId(prefix = ""): string {
  // time-ordered prefix keeps ids sortable by creation
  return prefix + Date.now().toString(36) + randomString(8);
}

export const STREAM_KEY = /^[a-z0-9][a-z0-9._-]{0,63}$/;

export function slugifyKey(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
}

/**
 * A stream key of a widget's own for a number typed into it: its name as a
 * key ("goal"), or that with a count ("goal-2"), never a key another stream,
 * source or widget already has, so two widgets with one name never share one
 * number and the first one's is never written over.
 */
export function freeStreamKey(name: string, used: (key: string) => boolean): string {
  const base = slugifyKey(name) || "value";
  let key = base;
  for (let i = 2; used(key); i++) key = `${base.slice(0, 60)}-${i}`;
  return key;
}
